// extracted by mini-css-extract-plugin
export default {"vaultDocContent":"styles_vaultDocContent__ZZPpj","title":"styles_title__dU8h6","counter":"styles_counter__O3CkM","ant-table-cell":"styles_ant-table-cell__z9-X0"};